import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError, initialize } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import InputControl from './../FormTemplate/InputControl';

class EditManufacturerForm extends React.Component {

   componentDidMount() {
      const { id } = this.props.params;
      axios.get(`manufacturers/getById/${id}`)
         .then((res) => {
            this.props.dispatch(initialize('editManufacturerForm', res.data));
         });
   }

   update = (values) => {
      const { id } = this.props.params;
      return axios.post(`manufacturers/update/${id}`, values)
         .then((res) => {
            if (res.status === 204) {
               alert.success('Updated Success');
               this.context.router.push('manufacturer');
            } else {
               alert.error('Something Went Wrong. Call Rasel');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      return (
         <div>
            <h3>Edit Manufacturer Form</h3>
            <form onSubmit={handleSubmit(this.update)} autoComplete="off" noValidate >
               <Field name="name" component={InputControl} type="text" label="Name" />

               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Save</Button>
            </form>
         </div>
      );
   }
}

EditManufacturerForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func,
   params: PropTypes.object,
   id: PropTypes.number
};

EditManufacturerForm.contextTypes = {
   router: PropTypes.object.isRequired
};

EditManufacturerForm = reduxForm({ // eslint-disable-line
   form: 'editManufacturerForm'
})(EditManufacturerForm);

export default EditManufacturerForm;



/** WEBPACK FOOTER **
 ** ./src/components/Manufacturer/EditManufacturerForm.js
 **/